import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';

// ==================== MODAL DE ACCESIBILIDAD ====================
export default function AccessibilityModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-800">Declaración de Accesibilidad</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="prose prose-sm max-w-none text-gray-700">
            <p>
              José Luis Construcciones se compromete a hacer que su sitio web sea accesible para todas las personas,
              incluyendo aquellas con discapacidades. Nos esforzamos por cumplir con las pautas de accesibilidad WCAG 2.1 Nivel AA.
            </p>

            <h4>Requisitos de Accesibilidad WCAG 2.1 Nivel AA Cumplidos</h4>
            <div className="space-y-4">
              <div>
                <h5 className="font-semibold text-gray-800">1. Perceptible</h5>
                <ul className="list-disc list-inside ml-4">
                  <li>Texto alternativo descriptivo para todas las imágenes</li>
                  <li>Contraste de color mínimo de 4.5:1 para texto normal y 3:1 para texto grande</li>
                  <li>Contenido no limitado únicamente al color</li>
                  <li>Posibilidad de aumentar el tamaño del texto hasta 200% sin pérdida de funcionalidad</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-800">2. Operable</h5>
                <ul className="list-disc list-inside ml-4">
                  <li>Navegación completa por teclado</li>
                  <li>Tiempo suficiente para leer y usar el contenido</li>
                  <li>Contenido que no cause convulsiones (no parpadeo rápido)</li>
                  <li>Posibilidad de navegar y encontrar contenido fácilmente</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-800">3. Comprensible</h5>
                <ul className="list-disc list-inside ml-4">
                  <li>Lenguaje claro y simple</li>
                  <li>Contenido presentado de manera predecible</li>
                  <li>Ayuda disponible para prevenir y corregir errores</li>
                  <li>Contenido legible y comprensible</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-800">4. Robusto</h5>
                <ul className="list-disc list-inside ml-4">
                  <li>Compatibilidad con tecnologías de asistencia actuales y futuras</li>
                  <li>Código HTML válido y semántico</li>
                  <li>Funcionalidad accesible mediante API de accesibilidad</li>
                </ul>
              </div>
            </div>

            <h4>Características de Accesibilidad Implementadas</h4>
            <ul className="list-disc list-inside">
              <li>Navegación por teclado completa (Tab, Enter, Escape)</li>
              <li>Texto alternativo descriptivo para todas las imágenes</li>
              <li>Contraste de color WCAG AA compliant</li>
              <li>Estructura semántica con encabezados jerárquicos (H1-H6)</li>
              <li>Compatibilidad con lectores de pantalla (NVDA, JAWS, VoiceOver)</li>
              <li>Formularios con etiquetas asociadas y mensajes de error</li>
              <li>Enlaces descriptivos que indican su propósito</li>
              <li>Contenido multimedia con transcripciones cuando es necesario</li>
            </ul>

            <h4>Si necesita asistencia adicional</h4>
            <p>
              Si experimenta dificultades para acceder a cualquier parte de nuestro sitio web
              o necesita información en formatos alternativos, por favor contáctenos:
            </p>
            <ul className="list-disc list-inside">
              <li><strong>Teléfono:</strong> 953 03 95 67 / 650 44 13 96</li>
              <li><strong>Email:</strong> construccionesperezrosa@gmail.com</li>
              <li><strong>Horario de atención:</strong> Lunes a Viernes 9:00-14:00 y 17:00-20:00</li>
            </ul>

            <p>
              Nos comprometemos a responder a su consulta en un plazo máximo de 48 horas
              y a proporcionar la asistencia necesaria para garantizar el acceso universal a nuestros servicios.
            </p>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>Última evaluación de accesibilidad:</strong> {new Date().toLocaleDateString('es-ES')}
                <br />
                <strong>Cumplimiento:</strong> WCAG 2.1 Nivel AA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
